// extracted by mini-css-extract-plugin
export default {"roomscene":"RoomScene_roomscene__qL4D8","active":"RoomScene_active__dHzoS"};